import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "dots-container"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return __props.loading ? (_openBlock(), _createElementBlock("section", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
        return _createElementVNode("div", {
          class: "dot",
          key: n,
          style: _normalizeStyle({
            animationDelay: `${(n - 3) * 0.2}s`
          })
        }, null, 4);
      }), 64))])) : _createCommentVNode("", true);
    };
  }
});